var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactSalesPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 83,
    viewBox: "0 0 80 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2185 42.3409L72.8713 28.2635V58.5905L45.1485 72.2714L45.2185 42.3409ZM10.297 21.9489L41.1881 7.69146L69.4898 21.9695L41.6668 36.1336L10.297 21.9489ZM40.961 0L0 19.2888L0.0725452 38.3393L7.12868 41.8499L7.07383 27.6317L38.0198 42.4173L37.948 72.7428L7.12878 56.761L7.10541 50.7259L9.76382e-05 47.191L0.0543259 61.1613L40.8973 82.3407L80 63.0438V19.3337L40.961 0Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6733 13.236L26.1387 6.89941L66.5347 26.8852L66.5468 39.6258L54.6535 44.825V33.5846L12.6733 13.236Z",
    fill: "#A9CF3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6538 75.4499V63.7316L66.535 57.8076V69.7806L54.6538 75.4499Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSalesPricing);
export default __webpack_public_path__ + "static/media/contact-sales-pricing.a1e841ddb7f9d5f0b92d739a67bde108.svg";
export { ForwardRef as ReactComponent };